<template>
  <div>
    <p class="titleModal">
      {{ $t('forms.labels.norms') }}
    </p>
    <VTextField
      v-model="data.treatment"
      :label="$t('forms.labels.treatment')"
      :rules="{ required: true, min: 1, max: 200 }"
      outlined
      data-cy="cyArTreatment"
    />
    <VAutocomplete
      v-model="data.applicableNorms"
      outlined
      :label="$t('analysisRequests.labels.applicableNorms')"
      :items="standardFamilies"
    />
  </div>
</template>

<script>
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    components: {
        VAutocomplete,
        VTextField,
    },
    props: {
        analysisRequest: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            standardFamilies: [],
            data: {
                applicableNorms: this.analysisRequest.applicableNorms,
                treatment: this.analysisRequest.treatment,
            },
        };
    },
    watch: {
        data: {
            handler() {
                this.$emit('updateData', this.data);
            },
            deep: true,
        },
    },
    async created() {
        await this.getApplicableNorms();
    },
    methods: {
        async getApplicableNorms() {
            const { data } = await this.$rq.getStandardFamilies();
            this.standardFamilies = data.standardFamilies;
        },
    },
};
</script>
